import React from 'react';
import { css } from '@emotion/css';
import { Benefit } from '../../../../../../../@types/benefits';
import { useGetNotifications } from '../../../../../../../apiHooks/notifications.hook';
import { GenericNotification } from '../../../../../../common/display/genericNotification/GenericNotification';
import { useIntl } from '@/i18n/hooks/useIntl';

const styles = {
  contentText: css`
    padding: 8px 0;
  `,
};

const Notifications = React.memo(() => {
  const { t } = useIntl();
  const { notifications } = useGetNotifications();

  if (!notifications || !notifications?.BILLCHECK?.statusMessage) return null;
  if (notifications.BILLCHECK.statusMessage.key !== 'billcheck_action_required') return null;

  return (
    <GenericNotification
      headline={t({
        id: 'benefits.billCheckV3.modal.overview.billCheckNotification.headline',
        defaultMessage: 'Fehlende Angaben',
      })}
      benefit={Benefit.BILLCHECK}
      content={
        <>
          <p className={styles.contentText}>
            {t({
              id: 'benefits.billCheckV3.modal.overview.billCheckNotification.description1',
              defaultMessage: 'Bitte vervollständige noch die letzten Angaben.',
            })}
          </p>
          <a href={notifications.BILLCHECK.statusMessage.params.ticketStatusUrl}>
            {t({
              id: 'benefits.billCheckV3.modal.overview.billCheckNotification.description2',
              defaultMessage: 'Auftrag fortsetzen',
            })}
          </a>
        </>
      }
      statusType='info'
    />
  );
});

export default Notifications;
